/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import styled from 'styled-components';
import LeaveInfoCard from './LeaveInfoCard';
import DateRangeModal from 'components/pages/leave-management/DateRangeModal';
import { leaveList } from 'store/leaveSlice';

const Container = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	min-height: 100vh;
	background-color: ${(props) => props.theme.colors.Cultured};
	overflow-y: auto;
`;

export default function LeaveInfo() {
	const dispatch = useDispatch();
	const { leaveListData = [], filterApply = false } = useSelector((state) => state.leave);
	const [leaveData, setLeaveData] = useState(leaveListData);
	const { filterDates = [] } = useSelector((state) => state.leave);
	const { selectedFilter = '' } = useSelector((state) => state.leave);
	const [showModal, setShowModal] = useState(false);
	const hideModal = () => {
		setShowModal(false);
	};

	useEffect(() => {
		dispatch(leaveList());
	}, [dispatch]);

	useEffect(() => {
		if (selectedFilter === 'DateRange' && filterDates.length === 0) {
			setShowModal(true);
		} else setShowModal(false);

		if (selectedFilter !== '' && selectedFilter !== 'DataRange') {
			const statusData = (st) =>
				leaveListData.map((arr) => arr.filter((dt) => dt.status === st));

			setLeaveData(statusData(selectedFilter));
		} else setLeaveData(leaveListData);

		if (filterDates.length === 0 && (selectedFilter === '' || selectedFilter === 'DateRange')) {
			setLeaveData(leaveListData);
		}

		if (filterDates.length === 0 && filterApply === true) {
			message.info('Data Not Found');
		}
	}, [filterApply, filterDates, leaveListData, selectedFilter]);

	return (
		<Container modal={showModal}>
			{filterApply
				? filterDates.map((dt) => (
						<LeaveInfoCard
							key={dt?.date}
							leaveDate={dt?.date}
							status={dt?.status}
							dateRange={showModal}
						/>
				  ))
				: leaveData.map((dt) =>
						dt?.map((ar) => (
							<LeaveInfoCard
								key={ar?.date}
								leaveDate={ar?.date}
								status={ar?.status}
								dateRange={showModal}
							/>
						))
				  )}
			{showModal && <DateRangeModal visible={showModal} hide={hideModal} />}
		</Container>
	);
}
